module.exports = __webpack_public_path__ + "static/media/3-1.1fd84528.mp3";